<div [innerHTML]="(patternData?.body ? patternData?.body : null) | safeHtml" class="code-output-content"></div>